"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAssetToLabelText = void 0;
const client_1 = require("@apollo/client");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_1 = require("react");
function useAssetToLabelText(locationId, floorLevel) {
    const { data } = client_1.useQuery(QUERY, {
        variables: {
            locationId,
            floorLevel,
        },
        context: { locationId },
        skip: floorLevel === null,
    });
    return react_1.useMemo(() => {
        if (!data || !data.location || !data.location.units || !data.location.units.list) {
            return {};
        }
        const result = {};
        data.location.units.list.forEach((unit) => {
            var _a;
            if (((_a = unit === null || unit === void 0 ? void 0 : unit.showLabel) === null || _a === void 0 ? void 0 : _a.propertyValue) === 'true' && unit.unitAddress && unit.unitAddress.did) {
                result[unit.unitAddress.did] = unit.name;
            }
        });
        return result;
    }, [data]);
}
exports.useAssetToLabelText = useAssetToLabelText;
const QUERY = graphql_tag_1.default `
  query AssetLabelDataForId($locationId: String!, $floorLevel: Int) {
    location(locationId: $locationId) {
      key
      units(first: 10000, floorLevel: $floorLevel) {
        list {
          key
          unitAddress {
            did
            key
          }
          name
          showLabel: customProperty(propertyName: "showLabel") {
            propertyValue
            key
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=useAssetToLabelText.js.map